import React, { useState, useEffect } from "react";
import Header from "./common/Header";
import Banner from "./common/Banner";
import Footer from "./common/Footer";
import Services from "./common/Services";
import { TYPE_ARTICLE } from "./constans";
import { useParams } from "react-router-dom";
import { importAll } from "./helper";

function Detail() {
  const [data, setData] = useState({});
  const [banner, setBanner] = useState([]);
  const [avt, setAvt] = useState("");
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      const dataDtail = TYPE_ARTICLE.find((x) => x.id == id);
      setData(dataDtail);
      const images = importAll(
        require.context("../assets/images", false, /\.(png|jpe?g|svg)$/)
      );
      setBanner([images[dataDtail.banner_name]]);
      setAvt([images[dataDtail.avt]]);
    }
  }, [id]);
  return (
    <section className="container-full">
      <Header />
      <Banner data={banner} autoPlay={false} arrows={false} draggable={false} />
      <section class="w3l-specification-6">
        <div class="specification-6-mian py-5">
          <div class="container py-lg-4">
            <div class="row story-6-grids text-left">
              <div class="col-lg-5 story-gd">
                <img src={avt} class="img-fluid" alt="/" />
              </div>
              <div class="col-lg-7 story-gd pl-lg-4">
                <div class="title-content text-left">
                  <h6 class="sub-title">{data.type}</h6>
                  <h3 class="hny-title">
                    {data.name} - {data.dc}L
                  </h3>
                  <p class="mt-3">{data.description}</p>
                </div>
                <div class="skill_info mt-lg-5 mt-4">
                  <div class="stats_left">
                    <div class="counter_grid">
                      <div class="icon_info">
                        <p class="counter">Số chỗ ngồi</p>
                        <h4>{data.slot} Chỗ</h4>
                      </div>
                    </div>
                  </div>
                  <div class="stats_left">
                    <div class="counter_grid">
                      <div class="icon_info">
                        <p class="counter">Kiểu dáng</p>
                        <h4>{data.style}</h4>
                      </div>
                    </div>
                  </div>
                  <div class="stats_left">
                    <div class="counter_grid">
                      <div class="icon_info">
                        <p class="counter">Nhiên liệu</p>
                        <h4>{data.fuel}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="skill_info mt-lg-5 mt-4">
                  <div class="stats_left">
                    <div class="counter_grid">
                      <div class="icon_info">
                        <p class="counter">Xuất xứ</p>
                        <h4>{data.origin}</h4>
                      </div>
                    </div>
                  </div>
                  <div class="stats_left">
                    <div class="counter_grid">
                      <div class="icon_info">
                        <p class="counter">Giá từ</p>
                        <h4>
                          {data.fullPrice} <sup className="swiper-vn"> VND</sup>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Services />
      <Footer />
    </section>
  );
}

export default Detail;
